/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectHouseSideDto } from '../models/work-create-project-house-side-dto';
import { WorkProjectHouseSide } from '../models/work-project-house-side';
import { WorkUpdateProjectHouseSideDto } from '../models/work-update-project-house-side-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceProjectHouseSidesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId()` */
  static readonly SelfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectIdPath = '/v2/selfservice/project-house-sides/byProjectId/{projectId}';

  /**
   * Get all project house sides by project ID.
   *
   * Returns all house sides for the specified project if it belongs to the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectHouseSide>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceProjectHouseSidesService.SelfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectHouseSide>>;
      })
    );
  }

  /**
   * Get all project house sides by project ID.
   *
   * Returns all house sides for the specified project if it belongs to the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectHouseSide>> {
    return this.selfserviceProjectHouseSidesV2ControllerGetProjectHouseSidesByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectHouseSide>>): Array<WorkProjectHouseSide> => r.body)
    );
  }

  /** Path part for operation `selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides()` */
  static readonly SelfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSidesPath = '/v2/selfservice/project-house-sides/byProjectId/{projectId}';

  /**
   * Update calculationitems by current project house sides by project ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceProjectHouseSidesService.SelfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSidesPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Update calculationitems by current project house sides by project ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.selfserviceProjectHouseSidesV2ControllerRecalculateCalculationitemsForAllProjecthouseSides$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide()` */
  static readonly SelfserviceProjectHouseSidesV2ControllerCreateProjectHouseSidePath = '/v2/selfservice/project-house-sides';

  /**
   * Create a new project house side.
   *
   * Creates a new house side for the specified project if it belongs to the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide$Response(
    params: {
  
    /**
     * Project house side data to create
     */
    body: WorkCreateProjectHouseSideDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectHouseSide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceProjectHouseSidesService.SelfserviceProjectHouseSidesV2ControllerCreateProjectHouseSidePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectHouseSide>;
      })
    );
  }

  /**
   * Create a new project house side.
   *
   * Creates a new house side for the specified project if it belongs to the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide(
    params: {
  
    /**
     * Project house side data to create
     */
    body: WorkCreateProjectHouseSideDto
    },
    context?: HttpContext
  ): Observable<WorkProjectHouseSide> {
    return this.selfserviceProjectHouseSidesV2ControllerCreateProjectHouseSide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectHouseSide>): WorkProjectHouseSide => r.body)
    );
  }

  /** Path part for operation `selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide()` */
  static readonly SelfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSidePath = '/v2/selfservice/project-house-sides/{id}';

  /**
   * Update a project house side.
   *
   * Updates a project house side if it belongs to a project owned by the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide$Response(
    params: {

    /**
     * Project house side ID
     */
      id: number;
  
    /**
     * Project house side data to update
     */
    body: WorkUpdateProjectHouseSideDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectHouseSide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceProjectHouseSidesService.SelfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSidePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectHouseSide>;
      })
    );
  }

  /**
   * Update a project house side.
   *
   * Updates a project house side if it belongs to a project owned by the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide(
    params: {

    /**
     * Project house side ID
     */
      id: number;
  
    /**
     * Project house side data to update
     */
    body: WorkUpdateProjectHouseSideDto
    },
    context?: HttpContext
  ): Observable<WorkProjectHouseSide> {
    return this.selfserviceProjectHouseSidesV2ControllerUpdateProjectHouseSide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectHouseSide>): WorkProjectHouseSide => r.body)
    );
  }

}
